module.exports = __webpack_public_path__ + "static/media/Test1.dcd214f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/reportCards/Test1.png
// module id = 1216
// module chunks = 0